import React from 'react';
import { Box, Typography } from '@mui/material';
import ArrowBackIosNewTwoToneIcon from '@mui/icons-material/ArrowBackIosNewTwoTone';
import { useNavigate, useParams } from 'react-router-dom';

const RunScriptHeading: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const handleBackToTasks = () => {
    navigate(`/project/${id}?tab=task`);
  };

  return (
    <Box
      sx={{
        bgcolor: '#FFFFFF',
        borderColor: '#E8EAEF',
        borderRadius: '8px',
        padding: '16px 24px',
        height: '84px',
      }}
    >
      <Typography
        paragraph
        sx={{
          display: 'flex',
          alignItems: 'center',
          fontWeight: 600,
          fontSize: '12px',
          lineHeight: '18px',
          mb: '5px',
          cursor: 'pointer',
        }}
        onClick={handleBackToTasks}
      >
        <ArrowBackIosNewTwoToneIcon sx={{ fontSize: 'inherit', cursor: 'pointer' }} />
        Back to Tasks
      </Typography>
      <Typography paragraph sx={{ fontWeight: 600, fontSize: '24px', lineHeight: '36px' }}>
        Script Execution
      </Typography>
    </Box>
  );
};

export default RunScriptHeading;
